module.exports = __webpack_public_path__ + "img/icon_s-2.1.4f83017b.svg";